/** Class performing actions within the main site container */
class SiteMain {
    /**
     * Define vimeo players container
     */
    constructor(elem) {
        this.elem = elem;
        this.iframes = this.elem.querySelectorAll('iframe');
    }

    /**
     * Initialization method
     */
    init() {
        this.initIntersectionObserver();
    }

    /**
     * Setup Intersection Observer for vimeo videos
     */
    initIntersectionObserver() {
        const vimeoVideoObserver = new IntersectionObserver((videos) => {
            videos.forEach((video) => {
                const player = new Vimeo.Player(video.target);
                if (video.isIntersecting) {
                    player.play();
                    return;
                }
                player.pause();
            });
        });

        this.iframes.forEach((iframe) => {
            if (iframe.src.indexOf('https://player.vimeo.com') === 0 && iframe.src.indexOf('autoplay=1') >= 0) {
                vimeoVideoObserver.observe(iframe);
            }
        });
    }
}

export default SiteMain;
